import { Navigate, Route, Routes } from "react-router-dom";
import { StudentAdminQuizz } from "../components/admin/StudentAdmin/Quizz/Quizzes";

import { StudentAdminCertificate } from "../components/admin/StudentAdmin/Award/Certificates/Certificates";
import { StudentAdminQuests } from "../components/admin/StudentAdmin/Quests/Quests";
import { StudentAdminDashboard } from "../components/admin/StudentAdmin/Dashboard/Dashboard";
import StudentAdminEpisodes from "../components/admin/StudentAdmin/Episodes/Quests/Episodes";
import { StudentAdminMap } from "../components/admin/StudentAdmin/Map/Map";
import { StudentAdminCongo } from "../components/admin/StudentAdmin/Congratulations/Congratulation";

import { StudentAdminProfile } from "../components/admin/StudentAdmin/Profile/Profile";
import { StudentAdminEpisodeDetail } from "../components/admin/StudentAdmin/Episodes/Quests/EpisodeDetail/EpisodeDetail";
import { StudentAdminTrailerDetail } from "../components/admin/StudentAdmin/Episodes/Quests/TrailerDetail";
import BeginQuizesPage from "../components/admin/StudentAdmin/Quizz/BeginQuiz/BeginQuiz";
import { StudentAdminQuestCertificate } from "../components/admin/StudentAdmin/Award/Certificates/QuestCertificates";
import { StudentAdminTrophy } from "../components/admin/StudentAdmin/Award/Trophy/Trophy";
import { StudentAdminCertificateOption } from "../components/admin/StudentAdmin/Award/AwardCertificateOption";
import { StudentFestiveMap } from "../components/admin/StudentAdmin/Festival/Festive";
import { StudentAdminTrophyCongo } from "../components/admin/StudentAdmin/Congratulations/TrophyCongratulation";
import StudentProtectedRoute from "../components/admin/StudentAdmin/ProtectedRoutes/ProtectedRoutes";
import StudentAdminFestival from "../components/admin/StudentAdmin/Episodes/Festivals/Festival";
import BeginQuizesPageFestive from "../components/admin/StudentAdmin/Quizz/BeginQuiz/BeginQuizFestive";
import { StudentAdminQuizzFestive } from "../components/admin/StudentAdmin/Quizz/QuizzesFestive";
import Layout from "../components/admin/StudentAdmin/layout/Layout";

const StudentAdminRoutes = () => (
  <>
    <Routes>
      <Route path="" element={<Layout userType="normal-student" />}>
        <Route path="start-your-quest" element={<StudentAdminDashboard />} />
        <Route path="festival" element={<StudentFestiveMap />} />
        <Route
          path="admin/episodes/:questId"
          element={<StudentAdminEpisodes />}
        />
        <Route
          path="admin/episodes/festive/detail/:questId/:chapterId"
          element={<StudentAdminFestival />}
        />
      </Route>
      <Route
        path=""
        element={
          <StudentProtectedRoute requiredRole={5}>
            <Layout userType="normal-student" />
          </StudentProtectedRoute>
        }
      >
        <Route
          path="admin/quiz/:questId/:chapterId"
          element={<StudentAdminQuizz />}
        />
        <Route
          path="admin/quiz/festive/:questId/:chapterId"
          element={<StudentAdminQuizzFestive />}
        />
        <Route
          path="admin/certificate-trophy"
          element={<StudentAdminCertificateOption />}
        />
        <Route path="admin/trophy" element={<StudentAdminTrophy />} />
        <Route
          path="admin/certificates"
          element={<StudentAdminCertificate />}
        />
        <Route
          path="admin/certificates/:questId"
          element={<StudentAdminQuestCertificate />}
        />

        <Route path="admin/quests" element={<StudentAdminQuests />} />
        <Route
          path="admin/quest"
          element={<Navigate to="/student/admin/quests" replace />}
        />

        <Route
          path="admin/episodes/detail/:questId/:chapterId"
          element={<StudentAdminEpisodeDetail />}
        />

        <Route
          path="admin/episode/detail/:questId"
          element={<StudentAdminEpisodeDetail />}
        />

        <Route path="admin/map" element={<StudentAdminMap />} />

        <Route
          path="admin/congratulation/:chapterId/:questId"
          element={<StudentAdminCongo />}
        />
        <Route
          path="admin/congratulation/trophy/:chapterId/:questId"
          element={<StudentAdminTrophyCongo />}
        />
        <Route path="admin/profile" element={<StudentAdminProfile />} />
        <Route
          path="admin/episode/trailer/detail/:questId"
          element={<StudentAdminTrailerDetail />}
        />
        <Route
          path="admin/quiz/begin/:questId/:chapterId"
          element={<BeginQuizesPage />}
        />
        <Route
          path="admin/quiz/festive/begin/:questId/:chapterId"
          element={<BeginQuizesPageFestive />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  </>
);

export default StudentAdminRoutes;
